import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=081e6b24&scoped=true&"
import script from "./NavigationPanel.vue?vue&type=script&lang=ts&"
export * from "./NavigationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationPanel.vue?vue&type=style&index=0&id=081e6b24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e6b24",
  null
  
)

export default component.exports